import { render, staticRenderFns } from "./CompaniesByTrackersAndCategoriesChart.vue?vue&type=template&id=6daa864a&"
import script from "./CompaniesByTrackersAndCategoriesChart.vue?vue&type=script&lang=js&"
export * from "./CompaniesByTrackersAndCategoriesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports